export default "__VITE_ASSET__CH8l7GJM__"